new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');

                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                }
            }

            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        const label = document.querySelector('.product-detail__header--infoArea-kit .label_attributes');
        const size = document.querySelector('.product-detail__size-guide');
        if (label && size) {
            label.append(size)
        }
        waitForElementToExist('.price-cupom').then(element => {
            const priceCupom = document.querySelector('.price-cupom b');

            if (priceCupom) {
                const priceCupomValue = priceCupom.textContent;

                if (priceCupomValue) {
                    let newValue = priceCupomValue;

                    if (priceCupom) {
                        priceCupom.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    var bannerHomeFull = $('.product-detail__banner__list');

    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 300,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    (function () {
        function validateKitVariations() {
            var variationGroups = {};

            $('.carousel-kit input[type="radio"]').each(function () {
                var inputName = $(this).attr('name');

                if (inputName) {
                    variationGroups[inputName] = true;
                }
            });

            var groupNames = Object.keys(variationGroups);

            if (!groupNames.length) {
                return;
            }

            var allSelected = groupNames.every(function (groupName) {
                return $('.carousel-kit input[type="radio"][name="' + groupName + '"]:checked').length > 0;
            });

            var $buyButtons = $(
                '.product-detail__header--infoArea .btn.btn-buy, ' +
                '.product-detail__header--infoArea .js-btn__product_detail__add_to_cart'
            );

            if (allSelected) {
                $buyButtons
                    .removeClass('no-buy disabled')
                    .prop('disabled', false)
                    .removeAttr('disabled')
                    .removeAttr('aria-disabled');
            } else {
                $buyButtons
                    .addClass('no-buy')
                    .prop('disabled', true)
                    .attr('aria-disabled', 'true');
            }
        }

        $(document).on(
            'change',
            '.carousel-kit input[type="radio"]',
            function () {
                setTimeout(validateKitVariations, 50);
                setTimeout(validateKitVariations, 200);
                setTimeout(validateKitVariations, 500);
            }
        );

        setTimeout(validateKitVariations, 500);
    })();

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(element => {
        // Controle de seleção dos tamanhos nos grupos (2 a 3 Uls possíveis)
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_IDS = ['#js_buy_together_api_group_0', '#js_buy_together_api_group_1', '#js_buy_together_api_group_2'];

        const getGroups = () => GROUP_IDS
            .map(sel => document.querySelector(sel))
            .filter(Boolean);

        const isAllowSelectProducts = () => {
            const buyTogetherApi = document.querySelector('.buy-together-api');
            return buyTogetherApi && buyTogetherApi.classList.contains('allow-select-products');
        };

        // Verifica se o grupo realmente precisa de seleção
        const groupRequiresSelection = (group) => {
            if (!group) return false;
            return !!group.querySelector('.product-item__options');
        };

        const getGroupsToCheck = () => {
            let allGroups = getGroups();

            // Remove grupos que não possuem opções e portanto não precisam ser selecionados
            allGroups = allGroups.filter(groupRequiresSelection);

            // Se tiver .allow-select-products, filtra apenas grupos com checkbox marcado
            if (isAllowSelectProducts()) {
                return allGroups.filter(group => {
                    const checkbox = group.querySelector('.checkbox-together-selectable');
                    return checkbox && checkbox.checked;
                });
            }

            return allGroups;
        };

        const isGroupSelected = (group) => {
            if (!group) return false;

            const options = group.querySelector('.product-item__options');

            // Se não existe opções, considera como "não precisa selecionar"
            if (!options) return true;

            // Seleção via select
            const select = options.querySelector('select');
            if (select) {
                const val = select.value;
                return val !== '' && val !== undefined && val !== null && val !== '0';
            }

            // Seleção via radio
            const radios = options.querySelectorAll('input[type="radio"]');
            if (radios.length) {
                return Array.from(radios).some(r => r.checked);
            }

            // Seleção via checkbox
            const checkboxes = options.querySelectorAll('input[type="checkbox"]');
            if (checkboxes.length) {
                return Array.from(checkboxes).some(c => c.checked);
            }

            // Outros inputs (fallback)
            const inputs = options.querySelectorAll('input');
            if (inputs.length) {
                return Array.from(inputs).some(i =>
                    (i.type !== 'radio' && i.type !== 'checkbox') &&
                    i.value &&
                    String(i.value).trim() !== ''
                );
            }

            // Se existe .product-item__options mas não encontrou campos selecionáveis,
            // considera como não obrigatório para não travar a compra
            return true;
        };

        const updateUI = () => {
            const allGroups = getGroups();
            const groupsToCheck = getGroupsToCheck();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);

            if (!allGroups.length || !addCartBtn) return;

            // Atualiza classe please-select apenas em grupos que realmente exigem seleção
            allGroups.forEach(group => {
                const requiresSelection = groupRequiresSelection(group);
                const selected = isGroupSelected(group);

                group.classList.toggle('please-select', requiresSelection && !selected);
            });

            // Libera compra quando todos os grupos que exigem seleção estiverem selecionados
            // Se não houver nenhum grupo exigindo seleção, libera normalmente
            const allSelected = groupsToCheck.every(g => isGroupSelected(g));
            addCartBtn.classList.toggle('no-buy', !allSelected);
        };

        const bindEvents = () => {
            const container = document.querySelector('#js_buy_together_api_layout_1_groups');
            const buyTogetherApi = document.querySelector('.buy-together-api');
            if (!container) return;

            // Delegação para mudanças em selects e inputs dentro dos grupos
            container.addEventListener('change', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;

                if (
                    target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2') ||
                    target.classList.contains('checkbox-together-selectable')
                ) {
                    updateUI();
                }
            }, { passive: true });

            // Alguns temas usam click para marcar radios customizados
            container.addEventListener('click', (e) => {
                const target = e.target;
                if (!(target instanceof Element)) return;

                if (
                    target.closest('#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2') ||
                    target.classList.contains('checkbox-together-selectable') ||
                    target.closest('.checkbox-together-selectable')
                ) {
                    setTimeout(updateUI, 0);
                }
            }, { passive: true });

            if (buyTogetherApi && buyTogetherApi.classList.contains('allow-select-products')) {
                const handleCheckboxChange = (e) => {
                    const target = e.target;
                    if (
                        target &&
                        (target.classList.contains('checkbox-together-selectable') ||
                            target.closest('.checkbox-together-selectable'))
                    ) {
                        updateUI();
                    }
                };

                const handleCheckboxClick = (e) => {
                    const target = e.target;
                    if (
                        target &&
                        (target.classList.contains('checkbox-together-selectable') ||
                            target.closest('.checkbox-together-selectable'))
                    ) {
                        setTimeout(updateUI, 10);
                    }
                };

                buyTogetherApi.addEventListener('change', handleCheckboxChange, { passive: true });
                buyTogetherApi.addEventListener('click', handleCheckboxClick, { passive: true });

                document.addEventListener('change', (e) => {
                    const target = e.target;
                    if (
                        target &&
                        target.classList.contains('checkbox-together-selectable') &&
                        buyTogetherApi.contains(target)
                    ) {
                        updateUI();
                    }
                }, { passive: true });

                document.addEventListener('click', (e) => {
                    const target = e.target;
                    if (
                        target &&
                        (target.classList.contains('checkbox-together-selectable') ||
                            target.closest('.checkbox-together-selectable')) &&
                        buyTogetherApi.contains(target.closest('.checkbox-together-selectable') || target)
                    ) {
                        setTimeout(updateUI, 10);
                    }
                }, { passive: true });

                const checkboxObserver = new MutationObserver((mutations) => {
                    let shouldUpdate = false;

                    mutations.forEach((mutation) => {
                        if (
                            mutation.type === 'attributes' &&
                            (mutation.attributeName === 'checked' || mutation.attributeName === 'class')
                        ) {
                            shouldUpdate = true;
                        }
                    });

                    if (shouldUpdate) {
                        updateUI();
                    }
                });

                const observeCheckboxes = () => {
                    const checkboxes = buyTogetherApi.querySelectorAll('.checkbox-together-selectable');
                    checkboxes.forEach(checkbox => {
                        checkboxObserver.observe(checkbox, {
                            attributes: true,
                            attributeFilter: ['checked', 'class']
                        });
                    });
                };

                const checkboxContainerObserver = new MutationObserver((mutations) => {
                    let shouldObserve = false;

                    mutations.forEach((mutation) => {
                        if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
                            shouldObserve = true;
                        }
                    });

                    if (shouldObserve) {
                        observeCheckboxes();
                        setTimeout(updateUI, 10);
                    }
                });

                checkboxContainerObserver.observe(buyTogetherApi, {
                    childList: true,
                    subtree: true,
                    attributes: false
                });

                observeCheckboxes();
            }

            // Observa mudanças dinâmicas (ex: render async dos grupos)
            const observer = new MutationObserver(() => {
                updateUI();
            });

            observer.observe(container, { childList: true, subtree: true });
        };

        bindEvents();
        updateUI();
    });

    waitForElementToExist('.product-rating__review-list').then(element => {
        const reviewList = document.querySelector(".product-rating__review-list");
        if (!reviewList) return;

        const reviews = Array.from(reviewList.children);
        const itemsPerPage = 5;

        if (reviews.length <= itemsPerPage) return;

        let currentPage = 1;
        const totalPages = Math.ceil(reviews.length / itemsPerPage);

        // Criar container da paginação
        const pagination = document.createElement("div");
        pagination.className = "review-pagination";
        pagination.style.marginTop = "15px";
        pagination.style.display = "flex";
        pagination.style.gap = "8px";
        pagination.style.alignItems = "center";
        pagination.style.flexWrap = "wrap";

        const prevBtn = document.createElement("button");
        prevBtn.textContent = "«";

        const nextBtn = document.createElement("button");
        nextBtn.textContent = "»";

        const numbersContainer = document.createElement("div");
        numbersContainer.style.display = "flex";
        numbersContainer.style.gap = "6px";

        pagination.appendChild(prevBtn);
        pagination.appendChild(numbersContainer);
        pagination.appendChild(nextBtn);

        reviewList.after(pagination);

        function renderPage(page) {
            currentPage = page;

            reviews.forEach((review) => {
                review.style.display = "none";
            });

            const start = (page - 1) * itemsPerPage;
            const end = start + itemsPerPage;

            reviews.slice(start, end).forEach((review) => {
                review.style.display = "";
            });

            updateActiveNumber();
            prevBtn.disabled = currentPage === 1;
            nextBtn.disabled = currentPage === totalPages;
        }

        function updateActiveNumber() {
            const buttons = numbersContainer.querySelectorAll("button");
            buttons.forEach((btn, index) => {
                btn.style.fontWeight = index + 1 === currentPage ? "bold" : "normal";
                btn.style.textDecoration = index + 1 === currentPage ? "underline" : "none";
            });
        }

        function createNumberButtons() {
            for (let i = 1; i <= totalPages; i++) {
                const numBtn = document.createElement("button");
                numBtn.textContent = i;

                numBtn.addEventListener("click", function () {
                    renderPage(i);
                });

                numbersContainer.appendChild(numBtn);
            }
        }

        prevBtn.addEventListener("click", function () {
            if (currentPage > 1) {
                renderPage(currentPage - 1);
            }
        });

        nextBtn.addEventListener("click", function () {
            if (currentPage < totalPages) {
                renderPage(currentPage + 1);
            }
        });

        createNumberButtons();
        renderPage(1);
    });

    $("body").on("click", ".btn-group.btn-minus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        }

        if (qtd > 1) qtd--;
        qt_el.val(qtd);
    });

    $("body").on("click", ".btn-group.btn-plus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        } else {
            qtd++;
        }
        qt_el.val(qtd);
    });

    if (window.matchMedia("(min-width: 992px)").matches) {
        let lastScrollTop = 0;

        function animeScroll() {
            const photoScroll = document.querySelector('.product-detail__header--photoArea');
            const productHeader = document.querySelector('.product-detail__header');
            const banner = document.querySelector('.product-detail__banner');
            const appHeader = document.getElementById('app_header');

            if (photoScroll) {
                const infoArea = document.querySelector('.product-detail__header--infoArea');
                const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
                const containerHeight = $container.outerHeight();
                const containerTop = $container.offset() ? $container.offset().top : 0;
                const sidebarOuterHeight = $('.sidebar__inner').outerHeight();
                const containerWidth = $container.width();
                const totalHeight = containerHeight - sidebarOuterHeight; // deslocamento máximo relativo ao container
                const pageTop = window.scrollY;

                // Verifica se existe banner e calcula quando ele sai da tela
                let bannerOffset = 0;
                if (banner) {
                    const bannerRect = banner.getBoundingClientRect();
                    const bannerHeight = banner.offsetHeight;
                    bannerOffset = bannerHeight;
                }

                // Calcula a altura do header para o top na volta
                let headerHeight = 0;
                let headerCurrentBottom = 0;
                if (appHeader) {
                    headerHeight = appHeader.offsetHeight;
                    headerCurrentBottom = Math.max(0, appHeader.getBoundingClientRect().bottom);
                }

                // Limites de scroll baseados no container e header
                const safeTotalHeight = Math.max(0, totalHeight);
                const endScroll = containerTop + containerHeight - headerHeight - sidebarOuterHeight; // ponto para parar a fixação

                // Verifica em tempo real se o product-detail__header chegou ao topo (tocou o app_header)
                const headerReachedTop = productHeader
                    ? productHeader.getBoundingClientRect().top <= headerCurrentBottom
                    : pageTop > containerTop - headerHeight;

                if (!headerReachedTop) {
                    // Antes do product-detail__header tocar o app_header: posição normal
                    $('.sidebar__inner').css({ position: 'relative' });
                    $('.sidebar__inner').css({ top: "0px" });
                    $('.sidebar__inner').css({ width: "100%" });
                    $('.sidebar__inner').css({ maxWidth: "100%" });
                } else if (pageTop >= endScroll) {
                    // Depois do final do container: travado no rodapé do container
                    $('.sidebar__inner').css({ position: 'relative' });
                    $('.sidebar__inner').css({ top: safeTotalHeight + "px" });
                    $('.sidebar__inner').css({ width: "100%" });
                    $('.sidebar__inner').css({ maxWidth: "100%" });
                } else {
                    // Dentro da faixa: fixo logo abaixo do header e com a largura do container
                    $('.sidebar__inner').css({ position: 'fixed' });
                    $('.sidebar__inner').css({ top: headerCurrentBottom + "px" });
                    if (containerWidth) {
                        $('.sidebar__inner').css({ width: containerWidth + "px" });
                        $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
                    }
                }

                lastScrollTop = pageTop;
            }
        }

        window.addEventListener('scroll', function () {
            if (screen.width > 991) {
                const photoScroll = document.querySelector('.product-detail__header--photoArea');
                if (photoScroll) {
                    animeScroll();
                }
            }
        });

        window.onresize = function () {
            const photoScroll = document.querySelector('.product-detail__header--photoArea');
            if (photoScroll) {
                if ($('.sidebar__inner').css('position') === 'fixed') {
                    const infoArea = document.querySelector('.product-detail__header--infoArea');
                    const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
                    const containerWidth = $container.width();
                    if (containerWidth) {
                        $('.sidebar__inner').css({ width: containerWidth + "px" });
                        $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
                    }
                }
            }
        };
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    if (window.matchMedia("(max-width: 991px)").matches) {
        const compreJunto = document.querySelector('#js_buy_together_api_layout_1');
        if (compreJunto) {
            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                            if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
                                const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
                                const options = targetNode.querySelector('.product-item__options');
                                const figcaption = targetNode.querySelector('.info-product');

                                if (options && figcaption) {
                                    figcaption.append(options);
                                }

                                const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                                const sizes = targetNode.querySelector('.product-radio-variation');

                                if (widget && sizes) {
                                    widget.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                    });

                                    const allSizes = sizes.querySelectorAll('label');
                                    allSizes.forEach(size => {
                                        size.addEventListener('click', () => {
                                            sizes.classList.toggle('active');
                                            widget.setAttribute('data-before', size.textContent);
                                        });
                                    });
                                }

                            }
                            if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                                const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                                const options = targetNode.querySelector('.product-item__options');
                                const figcaption = targetNode.querySelector('.info-product');

                                if (options && figcaption) {
                                    figcaption.append(options);
                                }

                                const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                                const sizes = targetNode.querySelector('.product-radio-variation');

                                if (widget && sizes) {
                                    widget.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                    });

                                    const allSizes = sizes.querySelectorAll('label');
                                    allSizes.forEach(size => {
                                        size.addEventListener('click', () => {
                                            sizes.classList.toggle('active');
                                            widget.setAttribute('data-before', size.textContent);
                                        });
                                    });
                                }

                            }
                            if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                                const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                                const options = targetNode.querySelector('.product-item__options');
                                const figcaption = targetNode.querySelector('.info-product');

                                if (options && figcaption) {
                                    figcaption.append(options);
                                }

                                const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                                const sizes = targetNode.querySelector('.product-radio-variation');

                                if (widget && sizes) {
                                    widget.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                    });

                                    const allSizes = sizes.querySelectorAll('label');
                                    allSizes.forEach(size => {
                                        size.addEventListener('click', () => {
                                            sizes.classList.toggle('active');
                                            widget.setAttribute('data-before', size.textContent);
                                        });
                                    });
                                }

                            }
                        }
                    });
                });
            });

            observer.observe(compreJunto, {
                childList: true,
                subtree: true
            });

        }
    }

    if ($('.description-resumida')) {
        $('.description-resumida .description-resumida--title').click(function () {
            $('.description-resumida .description-resumida--content').toggleClass('active');
        })
    }

    if ($('.product-detail__header--photoArea-mobile, .mobile-slider')) {
        $('.product-detail__header--photoArea-mobile, .mobile-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            speed: 700,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('.how-use__list')) {
        $('.how-use__list').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 700,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3
                    }
                },
            ]
        });
    }

    if ($('#product-detail-related-carrousel')) {
        $('#product-detail-related-carrousel').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                        appendArrows: $('.group-arrows')
                    }
                },
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();

    const faqItems = document.querySelectorAll('.home__faq--list-item');

    if (faqItems.length > 0) {
        faqItems.forEach(item => {
            item.addEventListener('click', () => {
                item.classList.toggle('active');
            });
        });
    }

    $(shipping_service).bind("onSuccessGetShippingProduct", function (event, data, cep_destino, produto_id, textStatus, jqXHR) {
        setTimeout(function () {
            var tableBody = $('#js_shipping_calculation_table_body');
            var rows = tableBody.find('tr');
            var max_visible = 5;

            $('#js_freight_show_more_btn').remove();

            if (rows.length) {
                rows.each(function () {
                    let lastTd = $(this).find('td:last-child');

                    if (lastTd.length) {
                        lastTd.find('br:last').remove();
                        lastTd.contents().last().remove();
                    }
                });
            }

            if (rows.length > max_visible) {
                rows.each(function (i) {
                    if (i >= max_visible) {
                        $(this).addClass('js_freight_hidden_row').hide();
                    }
                });

                $('<button id="js_freight_show_more_btn">Ver mais fretes</button>')
                    .insertAfter('#js_shipping_calculation_table')
                    .on('click', function () {
                        var hidden = tableBody.find('.js_freight_hidden_row');
                        var isExpanded = hidden.is(':visible');
                        hidden.toggle(!isExpanded);
                        $(this).text(isExpanded ? 'Ver mais fretes' : 'Ver menos fretes');
                    });
            }
        }, 0);
    });

})